import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { localStorageKeys, userRoleNameEnum } from '../const/enum';

/**
 * Admin-only guard for the hidden Access Control (permission management) route.
 * Only super_admin may manage tabs/permissions. (site_admin users are mapped to
 * super_admin at login, so this covers both.)
 */
@Injectable({
  providedIn: 'root'
})
export class AccessControlGuard {
  constructor(
    private router: Router,
    private utilService: UtilService
  ) { }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role = this.utilService.loginUserType
      || this.utilService.getLocalStorage(localStorageKeys.roleType);

    if (role === userRoleNameEnum.superAdmin) {
      return true;
    }

    if (role === userRoleNameEnum.clientSupport) {
      this.router.navigate(['/client-support/dashboard']);
      return false;
    }

    this.router.navigate(['/new-dashboard']);
    return false;
  }
}
